import { it } from "date-fns/locale";
import { Calendar } from "./ui/calendar";

// Shared Equiro calendar primitive. Global pattern for EVERY date picker/calendar:
// header = [ ‹ ]  [ Mese ▼ ] [ Anno ▼ ]  [ › ] — prev/next arrows on the sides, month and
// year selectable via dropdowns (not a static label). IT locale, week starts Monday.
const EQ_CAL_CLASSNAMES = {
  caption: "flex justify-center items-center relative pt-1 px-9",
  caption_dropdowns: "flex gap-2",
  dropdown: "rdp-dropdown bg-white border border-[#E5DEC9] rounded-md px-1.5 py-1 text-sm text-[#1B3B2B] focus:outline-none focus:ring-2 focus:ring-[#8C532B]",
  caption_label: "hidden",
  vhidden: "sr-only",
  nav_button_previous: "absolute left-1",
  nav_button_next: "absolute right-1",
};

export function EquiroCalendar({ fromYear, toYear, classNames, ...props }) {
  const cy = new Date().getFullYear();
  const fy = fromYear ?? (cy - 40);
  const ty = toYear ?? (cy + 10);
  return (
    <Calendar
      captionLayout="dropdown-buttons" fromYear={fy} toYear={ty}
      locale={it} weekStartsOn={1}
      classNames={{ ...EQ_CAL_CLASSNAMES, ...(classNames || {}) }}
      {...props}
    />
  );
}
